var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAttachIcon = function SvgAttachIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "20px",
    viewBox: "0 0 13 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-a-subcollection-Copy-2",
    transform: "translate(-350.000000, -445.000000)",
    fill: "#5DC5EA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-folder---modal-Copy-2",
    transform: "translate(330.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bloque-permissions",
    transform: "translate(20.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sketch-color-picker-2-Copy",
    transform: "translate(0.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach-line-copy",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach-file-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25,26 C2.80334473,26 0,23.1966553 0,19.75 L0,11 C0,10.5391846 0.373382578,10.1667175 0.833282461,10.1667175 C1.29333496,10.1667175 1.66671754,10.5391846 1.66671754,11 L1.66671754,19.75 C1.66671754,22.2767029 3.72253418,24.3332825 6.25,24.3332825 C8.77746582,24.3332825 10.8332825,22.2767029 10.8332825,19.75 L10.8332825,10.5832825 C10.8332825,8.97500609 9.52499391,7.66671754 7.91671754,7.66671754 C6.30828859,7.66671754 5,8.97500609 5,10.5832825 L5,18.9167175 C5,19.6058045 5.56076051,20.1667175 6.25,20.1667175 C6.93923949,20.1667175 7.5,19.6058045 7.5,18.9167175 L7.5,11 C7.5,10.5391846 7.87338258,10.1667175 8.33328246,10.1667175 C8.79333496,10.1667175 9.16671754,10.5391846 9.16671754,11 L9.16671754,18.9167175 C9.16671754,20.5249939 7.85827637,21.8332825 6.25,21.8332825 C4.64172363,21.8332825 3.33328246,20.5249939 3.33328246,18.9167175 L3.33328246,10.5832825 C3.33328246,8.05673219 5.38909914,6 7.91671754,6 C10.4441834,6 12.5,8.05673219 12.5,10.5832825 L12.5,19.75 C12.5,23.1966553 9.69665527,26 6.25,26 Z",
    id: "Path"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttachIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attachIcon.593687d3.svg";
export { ForwardRef as ReactComponent };